(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('SignupCheckout', [
			'$document',
			'$timeout',
			'APP_BASE_PATH',
			'globalConfig',
			'HTTP_STATUS',
			'mixpanelFactory',
			'urlFactory',
			'vcRecaptchaService',
			SignupCheckoutFunction
		]);

	function SignupCheckoutFunction(
		$document,
		$timeout,
		APP_BASE_PATH,
		globalConfig,
		HTTP_STATUS,
		mixpanelFactory,
		urlFactory,
		vcRecaptchaService) {
		
		var checkout = this;
		var widgetId;
		
		checkout.$onInit = function() {
			angular.extend(checkout, globalConfig);
			loadDocuments();
		};

		checkout.setWidgetId = function(id){
			widgetId = id;
		};

		checkout.resetRecaptcha = function(){
			vcRecaptchaService.reload(widgetId);
			checkout.formSubmitted = false;
		};
		
		checkout.initRecaptcha = function(){
			vcRecaptchaService.execute(widgetId);
		};

		checkout.successfulRecaptcha = function(){
			checkout.recaptchaResponse = vcRecaptchaService.getResponse(widgetId);

			$timeout(function(){
				checkout.submit();
			});
		};

		checkout.submit = function(){
			var postBody = {
				firstName: checkout.firstName,
				lastName: checkout.lastName,
				email: checkout.email,
				password: checkout.password,
				termsAcknowledgedVersionId: checkout.termsOfService.documentRevisionId,
				privacyPolicyAcknowledgedVersionId: checkout.privacyPolicy.documentRevisionId,
				signupCaptchaAnswer: checkout.recaptchaResponse,
				clientId: checkout.apiClientId,
				riaPlanId: checkout.riaPlanId
			};

			if(angular.isDefined(mixpanelFactory.getDistinctId())) {
				postBody.mixpanelId = mixpanelFactory.getDistinctId();
			}
			
			if(angular.isDefined(checkout.universalControl)) {
				postBody.universalControl = checkout.universalControl; 
			}
			
			urlFactory.apiPostPromise('/api/user', postBody)
				.then(function(response) {
					checkout.accessToken = response.data.accessToken.access_token;
					checkout.expiresIn = response.data.accessToken.expires_in;
					checkout.refreshToken = response.data.accessToken.refresh_token;
					$timeout(function() {
						$document[0].getElementById('createUserSuccessForm').submit();
					});
				})
				.catch(function(response) {
					checkout.resetRecaptcha();
					var override = {};

					if(response.status === HTTP_STATUS.CONFLICT) {
						override.email = 'A user with this email already exists. Please <a href="' + APP_BASE_PATH + '/login">log&nbsp;in</a> to proceed.';
						mixpanelFactory.track('Attempted Signup with Existing Email', { 'email': postBody.email });
					}

					urlFactory.handleServerValidation(checkout.expandedSignUpForm, response, override);
				});
		};

		function loadDocuments() {
			var websiteDocumentsUrl = '/api/website-documents/terms-of-service-privacy-policy';

			urlFactory.apiGetPromise(websiteDocumentsUrl)
				.then(function (response) {
					checkout.privacyPolicy = {
							documentRevisionId: response.data.privacyPolicy.documentRevisionId,
							title: response.data.privacyPolicy.title,
							url:  response.data.privacyPolicy.url
					};
					checkout.termsOfService = {
							documentRevisionId: response.data.termsOfService.documentRevisionId,
							title: response.data.termsOfService.title,
							url:  response.data.termsOfService.url
					};
					checkout.clientAgreement = {
							documentRevisionId: response.data.fundriseClientAgreement.documentRevisionId,
							title: 'Client Agreement',
							url:  response.data.fundriseClientAgreement.url
					};
					checkout.formAdvPart2 = {
							documentRevisionId: response.data.formAdvPart2.documentRevisionId,
							title: 'Form ADV Part II',
							url:  response.data.formAdvPart2.url
					};
					checkout.loaded = true;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					checkout.expandedSignUpForm.$setValidity('documentLoadError', false);
				});
		}
	}
})(window.angular);